var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5793_21857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.125C7.09847 3.125 3.125 7.09847 3.125 12C3.125 16.9015 7.09847 20.875 12 20.875C16.9015 20.875 20.875 16.9015 20.875 12C20.875 7.09847 16.9015 3.125 12 3.125ZM0.875 12C0.875 5.85583 5.85583 0.875 12 0.875C18.1442 0.875 23.125 5.85583 23.125 12C23.125 18.1442 18.1442 23.125 12 23.125C5.85583 23.125 0.875 18.1442 0.875 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 16C10.875 15.3787 11.3787 14.875 12 14.875H12.01C12.6313 14.875 13.135 15.3787 13.135 16C13.135 16.6213 12.6313 17.125 12.01 17.125H12C11.3787 17.125 10.875 16.6213 10.875 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.875C12.6213 6.875 13.125 7.37868 13.125 8V12C13.125 12.6213 12.6213 13.125 12 13.125C11.3787 13.125 10.875 12.6213 10.875 12V8C10.875 7.37868 11.3787 6.875 12 6.875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5793_21857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.06bbb74ebb17cab48a6622827ad67814.svg";
export { ForwardRef as ReactComponent };